<template>
  <section class="cabinet cabinet-userdata">
    <h2 class="_fs-32 _lh-38 _tc-dark _fw-700 _mb-10">
      {{ $t("cabinet.dashboard.sections[0].title") }}
    </h2>
    <div class="d-flex align-start">
      <div class="userdata__avatar-block _mb-8 _mr-16 d-none d-xl-block">
        <div class="userdata__avatar">
          <div class="userdata__avatar-edit" @click="cropImage">
            <svg
              viewBox="0 0 44 44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                class="userdata__avatar-edit-back"
                x="1"
                y="1"
                width="42"
                height="42"
                rx="21"
                fill="currentColor"
              />
              <path
                class="userdata__avatar-edit-item"
                d="M27 13.0001C27.2626 12.7374 27.5744 12.5291 27.9176 12.3869C28.2608 12.2448 28.6286 12.1716 29 12.1716C29.3714 12.1716 29.7392 12.2448 30.0824 12.3869C30.4256 12.5291 30.7374 12.7374 31 13.0001C31.2626 13.2627 31.471 13.5745 31.6131 13.9177C31.7553 14.2608 31.8284 14.6286 31.8284 15.0001C31.8284 15.3715 31.7553 15.7393 31.6131 16.0825C31.471 16.4256 31.2626 16.7374 31 17.0001L17.5 30.5001L12 32.0001L13.5 26.5001L27 13.0001Z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <rect
                x="1"
                y="1"
                width="42"
                height="42"
                rx="21"
                stroke="white"
                stroke-width="2"
              />
            </svg>
          </div>
          <svg
            v-if="!user.photo"
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M43.3337 45.5V41.1667C43.3337 38.8681 42.4206 36.6637 40.7953 35.0384C39.1699 33.4131 36.9655 32.5 34.667 32.5H17.3337C15.0351 32.5 12.8307 33.4131 11.2054 35.0384C9.58008 36.6637 8.66699 38.8681 8.66699 41.1667V45.5"
              stroke="#B2B4B2"
              stroke-width="4.33333"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M25.9997 23.8333C30.7861 23.8333 34.6663 19.9531 34.6663 15.1667C34.6663 10.3802 30.7861 6.5 25.9997 6.5C21.2132 6.5 17.333 10.3802 17.333 15.1667C17.333 19.9531 21.2132 23.8333 25.9997 23.8333Z"
              stroke="#B2B4B2"
              stroke-width="4.33333"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <img v-else :src="'/' + user.photo" />
        </div>
      </div>
      <div class="userdata w-100">
        <div class="d-xl-flex w-100 _mb-10">
          <div class="d-flex _mr-auto _mb-md-8">
            <div class="userdata__avatar-block d-xl-none _mr-8">
              <div class="userdata__avatar">
                <div class="userdata__avatar-edit" @click="cropImage">
                  <svg
                    viewBox="0 0 44 44"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      class="userdata__avatar-edit-back"
                      x="1"
                      y="1"
                      width="42"
                      height="42"
                      rx="21"
                      fill="currentColor"
                    />
                    <path
                      class="userdata__avatar-edit-item"
                      d="M27 13.0001C27.2626 12.7374 27.5744 12.5291 27.9176 12.3869C28.2608 12.2448 28.6286 12.1716 29 12.1716C29.3714 12.1716 29.7392 12.2448 30.0824 12.3869C30.4256 12.5291 30.7374 12.7374 31 13.0001C31.2626 13.2627 31.471 13.5745 31.6131 13.9177C31.7553 14.2608 31.8284 14.6286 31.8284 15.0001C31.8284 15.3715 31.7553 15.7393 31.6131 16.0825C31.471 16.4256 31.2626 16.7374 31 17.0001L17.5 30.5001L12 32.0001L13.5 26.5001L27 13.0001Z"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <rect
                      x="1"
                      y="1"
                      width="42"
                      height="42"
                      rx="21"
                      stroke="white"
                      stroke-width="2"
                    />
                  </svg>
                </div>
                <svg
                  v-if="!user.photo"
                  width="52"
                  height="52"
                  viewBox="0 0 52 52"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M43.3337 45.5V41.1667C43.3337 38.8681 42.4206 36.6637 40.7953 35.0384C39.1699 33.4131 36.9655 32.5 34.667 32.5H17.3337C15.0351 32.5 12.8307 33.4131 11.2054 35.0384C9.58008 36.6637 8.66699 38.8681 8.66699 41.1667V45.5"
                    stroke="#B2B4B2"
                    stroke-width="4.33333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M25.9997 23.8333C30.7861 23.8333 34.6663 19.9531 34.6663 15.1667C34.6663 10.3802 30.7861 6.5 25.9997 6.5C21.2132 6.5 17.333 10.3802 17.333 15.1667C17.333 19.9531 21.2132 23.8333 25.9997 23.8333Z"
                    stroke="#B2B4B2"
                    stroke-width="4.33333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <img v-else :src="'/' + user.photo" />
              </div>
            </div>
            <div class="_my-md-auto">
              <div class="_fs-20 _lh-26 _tc-dark">
                {{ user.first_name + " " + user.last_name }}
              </div>
              <div class="_fs-20 _lh-26 _tc-dark-grey _mt-4">
                Herbalife ID: {{ user.username }}
              </div>
              <div class="_fs-20 _lh-26 _tc-dark-grey _mt-4">
                {{ user.status }}
              </div>
            </div>
          </div>
          <div class="d-md-flex">
            <div class="_ml-7 _ml-md-0 _mr-md-auto">
              <div class="progress__item d-flex">
                <Progress
                  :value="user.level_progress * 100"
                  :total="100"
                  class="_mr-4"
                >
                </Progress>
                <div class="_my-auto">
                  <div class="progress__text d-flex">
                    <div class="progress__title _fs-16 _lh-24 _tc-dark">
                      {{ $t("cabinet.dashboard.sections[0].statusText") }}
                    </div>
                    <div
                      class="_my-auto _ml-2 relative"
                      style="cursor: pointer"
                      @click="levelsFaq = true"
                    >
                      <svg
                        width="19"
                        height="18"
                        viewBox="0 0 19 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_3676_99243)">
                          <path
                            d="M6.375 6C6.375 5.40326 6.65156 4.83097 7.14384 4.40901C7.63613 3.98705 8.30381 3.75 9 3.75H9.75C10.4462 3.75 11.1139 3.98705 11.6062 4.40901C12.0984 4.83097 12.375 5.40326 12.375 6C12.4026 6.48694 12.2713 6.96967 12.0007 7.37548C11.7302 7.78129 11.3351 8.08821 10.875 8.25C10.4149 8.46572 10.0198 8.87494 9.74928 9.41602C9.47874 9.9571 9.34738 10.6007 9.375 11.25"
                            stroke="#629727"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M9.375 14.25V14.2575"
                            stroke="#629727"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <rect
                          x="1.125"
                          y="0.75"
                          width="16.5"
                          height="16.5"
                          rx="8.25"
                          stroke="#629727"
                          stroke-width="1.5"
                        />
                        <defs>
                          <clipPath id="clip0_3676_99243">
                            <rect
                              x="0.375"
                              width="18"
                              height="18"
                              rx="9"
                              fill="white"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      <!-- <div
                        class="progress-modal _py-14 _px-8 _br--2"
                        style="background-color: #eef3f7"
                      >
                        <div class="progress-modal__close">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6 6L18 18"
                              stroke="#7A8C97"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M18 6L6 18"
                              stroke="#7A8C97"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div class="_fs-24 _lh-32 _tc-dark _fw-700 _mb-4">
                          Система статусов пользователя:
                        </div>
                        <div class="_fs-16 _lh-24 _tc-dark-grey _mb-10">
                          Это тот грейд, который вы получаете по мере
                          продвижения в обучении.
                        </div>
                        <div class="progress-modal__levels">
                          <div
                            class="progress-modal__level progress-modal__level_active"
                          >
                            <svg
                              width="30"
                              height="30"
                              viewBox="0 0 30 30"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                width="30"
                                height="30"
                                rx="15"
                                fill="#77BB2F"
                              />
                              <path
                                d="M23 10L13.375 19L9 14.9091"
                                stroke="white"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            <div class="_ml-2 _fs-20 _lh-24 _tc-dark _fw-700">
                              Новичок
                            </div>
                          </div>
                          <div class="progress-modal__line"></div>
                          <div class="progress-modal__level">
                            <svg
                              width="30"
                              height="30"
                              viewBox="0 0 30 30"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                x="0.5"
                                y="0.5"
                                width="29"
                                height="29"
                                rx="14.5"
                                fill="white"
                              />
                              <path
                                d="M20 10L10 20M10 10L20 20"
                                stroke="#B2B4B2"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <rect
                                x="0.5"
                                y="0.5"
                                width="29"
                                height="29"
                                rx="14.5"
                                stroke="#D1D2CD"
                              />
                            </svg>

                            <div class="_ml-2 _fs-20 _lh-24 _tc-dark _fw-700">
                              Продвинутый
                            </div>
                          </div>
                          <div class="progress-modal__line"></div>
                          <div class="progress-modal__level">
                            <svg
                              width="30"
                              height="30"
                              viewBox="0 0 30 30"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                x="0.5"
                                y="0.5"
                                width="29"
                                height="29"
                                rx="14.5"
                                fill="white"
                              />
                              <path
                                d="M20 10L10 20M10 10L20 20"
                                stroke="#B2B4B2"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <rect
                                x="0.5"
                                y="0.5"
                                width="29"
                                height="29"
                                rx="14.5"
                                stroke="#D1D2CD"
                              />
                            </svg>

                            <div class="_ml-2 _fs-20 _lh-24 _tc-dark _fw-700">
                              Знаток
                            </div>
                          </div>
                          <div class="progress-modal__line"></div>
                          <div class="progress-modal__level">
                            <svg
                              width="30"
                              height="30"
                              viewBox="0 0 30 30"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                x="0.5"
                                y="0.5"
                                width="29"
                                height="29"
                                rx="14.5"
                                fill="white"
                              />
                              <path
                                d="M20 10L10 20M10 10L20 20"
                                stroke="#B2B4B2"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <rect
                                x="0.5"
                                y="0.5"
                                width="29"
                                height="29"
                                rx="14.5"
                                stroke="#D1D2CD"
                              />
                            </svg>

                            <div class="_ml-2 _fs-20 _lh-24 _tc-dark _fw-700">
                              Гуру
                            </div>
                          </div>
                        </div>
                      </div> -->
                    </div>
                  </div>
                  <div class="_fs-20 _lh-24 _tc-dark _fw-700">
                    {{ $t(`cabinet.dashboard.levels[${user.level}]`) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="_ml-7 _ml-md-0 _mt-sm-8">
              <div class="progress__item d-flex">
                <Progress :value="profileFilled" :total="100" class="_mr-4">
                  <template v-slot:progress="props">
                    <span class="_fs-13 _fw-700 _tc-dark-grey d-inline-block">{{
                      props.progress.value
                    }}</span>
                    <span class="_fs-13 _fw-400 _tc-dark-grey d-inline-block">
                      /{{ props.progress.total }}</span
                    >
                  </template>
                </Progress>
                <div class="progress__text d-flex">
                  <div
                    class="progress__title _fs-16 _lh-24 _tc-dark _my-auto"
                    v-html="$t('cabinet.complete_text')"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="_mb-8">
          <div class="_fs-20 _lh-24 _fw-700 _tc-dark">
            {{ $t("cabinet.dashboard.sections[0].persData") }}
          </div>
          <div class="_fs-16 _lh-24 _tc-green-second _mb-6">
            {{ $t("cabinet.dashboard.sections[0].persDataTip") }}
          </div>
          <div class="d-md-flex d-block justify-start align-start">
            <v-input
              :class="{ '_mb-10': !name.state }"
              class="_mb-4 _mr-4 _mr-sm-0 w-100"
              v-model="name.value"
              :state="name.state ? null : false"
              label-style="label-border"
              :label="$t('fields_labels.name') + '*'"
              :state-invalid-text="name.error"
              @change="validate(['name'])"
              @blur="validate(['name'])"
            >
              <template v-slot:clear>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13 1L1 13M1 1L13 13"
                    stroke="#B2B4B2"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </template>
            </v-input>
            <v-input
              :class="{ '_mb-10': !secondName.state }"
              class="_mb-4 _ml-4 _ml-sm-0 w-100"
              v-model="secondName.value"
              :state="secondName.state ? null : false"
              label-style="label-border"
              :label="$t('fields_labels.surname')"
              :state-invalid-text="secondName.error"
              @change="validate(['secondName'])"
              @blur="validate(['secondName'])"
            >
              <template v-slot:clear>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13 1L1 13M1 1L13 13"
                    stroke="#B2B4B2"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </template>
            </v-input>
          </div>
          <div class="d-md-flex d-block justify-start align-start">
            <v-input
              v-if="false"
              :class="{ '_mb-10': !lastName.state }"
              class="_mb-4 _mr-4 _mr-sm-0 w-100"
              v-model="lastName.value"
              :state="lastName.state ? null : false"
              label-style="label-border"
              :label="$t('fields_labels.lastname')"
            >
              <template v-slot:clear>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13 1L1 13M1 1L13 13"
                    stroke="#B2B4B2"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </template>
            </v-input>
            <div
              class="d-md-flex d-block justify-start align-start relative w-100 _mr-4 _mr-sm-0"
              @click="calendar = true"
            >
              <v-input
                v-mask="'##.##.####'"
                :class="{ '_mb-10': !birthday.state }"
                class="_mb-4 w-100"
                v-model="birthday.value"
                readonly="true"
                :state="birthday.state ? null : false"
                label-style="label-border"
                :label="$t('fields_labels.birthday')"
              >
                <template v-slot:clear>
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1L1 13M1 1L13 13"
                      stroke="#B2B4B2"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </template>
              </v-input>
              <Calendar
                v-if="calendar"
                @dayClick="dayClick"
                :currentDate="this.user.birthday"
                @closeCalendar="closeCalendar"
              />
            </div>
            <div class="w-100 _ml-4"></div>
          </div>
        </div>
        <div class="_mb-8">
          <div class="_fs-20 _lh-24 _fw-700 _tc-dark _mb-6">
            {{ $t("cabinet.dashboard.sections[0].contacts") }}
          </div>
          <div class="d-md-flex d-block justify-start align-start">
            <div class="_mr-4 _mr-sm-0 w-100">
              <v-input
                :class="{ '_mb-10': !email.state }"
                class="_mb-4 w-100"
                v-model="email.value"
                :readonly="!!user.email"
                :state="email.state ? null : false"
                label-style="label-border"
                label="Email*"
                :state-invalid-text="email.error"
                @change="validate(['email'])"
                @blur="validate(['email'])"
              >
                <template v-slot:clear>
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1L1 13M1 1L13 13"
                      stroke="#B2B4B2"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </template>
              </v-input>
              <!-- <div class="_fs-16 _lh-24 _tc-grey-light _mb-sm-4">
                {{ $t('cabinet.dashboard.sections[0].contactsTip') }}
              </div> -->
            </div>

            <div class="d-flex _ml-4 _ml-sm-0 _mb-4 w-100">
              <vue-country-code
                @onSelect="onSelectCountry"
                :enabledCountryCode="true"
                :disabledFetchingCountry="true"
                :defaultCountry="
                  user.ds_proc_country || countriesAssociation[user.language]
                "
                :onlyCountries="[
                  'AM',
                  'AT',
                  'AZ',
                  'BY',
                  'BE',
                  'BG',
                  'HR',
                  'CZ',
                  'DK',
                  'EE',
                  'FI',
                  'FR',
                  'GE',
                  'DE',
                  'GR',
                  'HU',
                  'IL',
                  'KZ',
                  'KG',
                  'LV',
                  'LT',
                  'MD',
                  'MN',
                  'NL',
                  'PL',
                  'PT',
                  'RO',
                  'RU',
                  'RS',
                  'ES',
                  'SE',
                  'TJ',
                  'TR',
                  'GB',
                  'US',
                  'UZ',
                ]"
              >
              </vue-country-code>
              <v-input
                :masked="false"
                v-mask="maskString"
                :class="{ '_mb-10': !phone.state }"
                class="w-100"
                v-model="phone.value"
                :state="phone.state ? null : false"
                :state-invalid-text="phone.error"
                label-style="label-border"
                :label="$t('fields_labels.phone')"
                @change="validate(['phone'])"
                @blur="validate(['phone'])"
              >
                <template v-slot:clear>
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1L1 13M1 1L13 13"
                      stroke="#B2B4B2"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </template>
              </v-input>
            </div>
          </div>
        </div>
        <div class="_mb-8">
          <div class="_fs-20 _lh-24 _fw-700 _tc-dark _mb-6">
            {{ $t("cabinet.dashboard.sections[0].address") }}
          </div>
          <div class="d-md-flex d-block justify-start align-start">
            <v-input
              :class="{ '_mb-10': !country.state }"
              class="_mb-4 _mr-sm-0 w-100"
              v-model="country.value"
              :state="country.state ? null : false"
              :state-invalid-text="country.error"
              label-style="label-border"
              :label="$t('fields_labels.country') + '*'"
              @change="validate(['country'])"
              @blur="validate(['country'])"
            >
              <template v-slot:clear>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13 1L1 13M1 1L13 13"
                    stroke="#B2B4B2"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </template>
            </v-input>
            <v-input
              :class="{ '_mb-10': !city.state }"
              class="_mb-4 _ml-4 _ml-sm-0 w-100"
              v-model="city.value"
              :state="city.state ? null : false"
              :state-invalid-text="city.error"
              label-style="label-border"
              name="city"
              :label="$t('fields_labels.city') + '*'"
              @change="validate(['city'])"
              @blur="validate(['city'])"
            >
              <template v-slot:clear>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13 1L1 13M1 1L13 13"
                    stroke="#B2B4B2"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </template>
            </v-input>
          </div>
          <AppBtn @click.native="saveData" class="_mb-6">
            <span class="_fs-16 _py-3 _px-25">{{ $t("cabinet.save") }}</span>
          </AppBtn>
        </div>
        <div class="_mb-8" v-if="false">
          <div class="_fs-20 _lh-24 _fw-700 _tc-dark _mb-6">
            {{ $t("cabinet.changePass") }}
          </div>
          <div class="d-md-flex d-block justify-start align-start">
            <v-input
              :class="{ '_mb-8': !password.state }"
              class="_mb-4 _mr-4 _mr-sm-0 w-100"
              v-model="password.value"
              :state="password.state ? null : false"
              :type="password.type"
              label-style="label-border"
              :label="$t('fields_labels.password')"
              :state-invalid-text="password.error"
              @blur="checkEqualPasswords"
            >
              <template v-slot:icon-append>
                <div @click="showPass">
                  <svg
                    v-if="password.type === 'text'"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1152_1106)">
                      <path
                        d="M14.12 14.12C13.8454 14.4147 13.5141 14.6512 13.1462 14.8151C12.7782 14.9791 12.3809 15.0673 11.9781 15.0744C11.5753 15.0815 11.1752 15.0074 10.8016 14.8565C10.4281 14.7056 10.0887 14.481 9.80385 14.1962C9.51897 13.9113 9.29439 13.5719 9.14351 13.1984C8.99262 12.8248 8.91853 12.4247 8.92563 12.0219C8.93274 11.6191 9.02091 11.2218 9.18488 10.8538C9.34884 10.4859 9.58525 10.1546 9.88 9.88M1 1L23 23M17.94 17.94C16.2306 19.243 14.1491 19.9649 12 20C5 20 1 12 1 12C2.24389 9.6819 3.96914 7.65661 6.06 6.06L17.94 17.94ZM9.9 4.24C10.5883 4.07888 11.2931 3.99834 12 4C19 4 23 12 23 12C22.393 13.1356 21.6691 14.2047 20.84 15.19L9.9 4.24Z"
                        stroke="#B2B4B2"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1152_1106">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <svg
                    v-else
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z"
                      stroke="#B2B4B2"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                      stroke="#B2B4B2"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </template>
            </v-input>

            <v-input
              :class="{ '_mb-8': !password_repeat.state }"
              class="_mb-4 _ml-4 _ml-sm-0 w-100"
              v-model="password_repeat.value"
              :state="password_repeat.state ? null : false"
              :type="password.type"
              label-style="label-border"
              :label="$t('fields_labels.password_repeat')"
              :state-invalid-text="password_repeat.error"
              @blur="checkEqualPasswords"
            >
              <template v-slot:icon-append>
                <div @click="showPass">
                  <svg
                    v-if="password.type === 'text'"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1152_1106)">
                      <path
                        d="M14.12 14.12C13.8454 14.4147 13.5141 14.6512 13.1462 14.8151C12.7782 14.9791 12.3809 15.0673 11.9781 15.0744C11.5753 15.0815 11.1752 15.0074 10.8016 14.8565C10.4281 14.7056 10.0887 14.481 9.80385 14.1962C9.51897 13.9113 9.29439 13.5719 9.14351 13.1984C8.99262 12.8248 8.91853 12.4247 8.92563 12.0219C8.93274 11.6191 9.02091 11.2218 9.18488 10.8538C9.34884 10.4859 9.58525 10.1546 9.88 9.88M1 1L23 23M17.94 17.94C16.2306 19.243 14.1491 19.9649 12 20C5 20 1 12 1 12C2.24389 9.6819 3.96914 7.65661 6.06 6.06L17.94 17.94ZM9.9 4.24C10.5883 4.07888 11.2931 3.99834 12 4C19 4 23 12 23 12C22.393 13.1356 21.6691 14.2047 20.84 15.19L9.9 4.24Z"
                        stroke="#B2B4B2"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1152_1106">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <svg
                    v-else
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z"
                      stroke="#B2B4B2"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                      stroke="#B2B4B2"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </template>
            </v-input>
          </div>
          <AppBtn @click.native="setPass">
            <span class="_fs-16 _py-3 _px-25">
              {{ $t("cabinet.changePassBtn") }}</span
            >
          </AppBtn>
        </div>
      </div>
    </div>
    <Avatar ref="cropper" @fetchFile="sendUserPhoto" />
    <Modal v-if="confirmEmail" @close="modalToggle('confirmEmail', false)">
      <template v-slot:modalBody>
        <div class="modal__body">
          <div
            class="modal__title _fs-sm-24 _lh-sm-32 _fs-32 _lh-38 _fw-700 _tc-dark _mb-4"
          >
            {{ $t("modals.confirmEmail.title") }}
          </div>
          <div class="_fs-16 _lh-24 _fw-400 _mb-4 _tc-dark-grey">
            {{ $t("modals.confirmEmail.description") }}
            <span class="_tc-green-second">{{ email.value }}</span>
          </div>

          <v-input
            :class="{ '_mb-10': !emailCode.state }"
            class="_mb-4 _mr-4 _mr-sm-0 w-100"
            v-model="emailCode.value"
            :state="emailCode.state ? null : false"
            label-style="label-border"
            :label="$t('fields_labels.code')"
            :state-invalid-text="emailCode.error"
            @change="validate(['email'])"
          >
            <template v-slot:clear>
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13 1L1 13M1 1L13 13"
                  stroke="#B2B4B2"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </template>
          </v-input>

          <div
            class="d-flex justify-start align-center _mt-8 direction-column-reverse direction-lg-row"
          >
            <AppBtn
              class="_mr-auto w-100 w-md-auto"
              @click.native="emailConfirm()"
            >
              <span class="_fs-16 _lh-24 _py-3 _py-sm-3 _px-4 _px-xs-0">
                {{ $t("interface.confirm") }}
              </span>
            </AppBtn>
          </div>
        </div>
      </template>
    </Modal>
    <Modal v-if="levelsFaq" @close="levelsFaq = false">
      <template v-slot:modalBody>
        <div v-html="$t('cabinet.dashboard.sections[0].statusModal')"></div>
      </template>
    </Modal>
  </section>
</template>

<script>
import { bus } from "@/main";
import AppBtn from "../../components/UI/buttons/AppBtn.vue";
import Progress from "../../components/UI/intensives/Progress.vue";
import validate from "@/mixins/validate";
import { mapActions, mapGetters } from "vuex";
import Avatar from "../../components/UI/cabinet/Avatar.vue";
import Calendar from "../../components/UI/cabinet/calendar/Calendar.vue";
import Modal from "@/components/UI/Modal";
export default {
  metaInfo() {
    return { title: this.$t("cabinet.dashboard.menu[1]") };
  },
  components: {
    AppBtn,
    Progress,
    Avatar,
    Calendar,
    Modal,
  },
  name: "CabinetUserData",
  mixins: [validate],
  data: () => ({
    levelsFaq: false,
    countryCode: { iso2: null, dialCode: null },
    confirmEmail: false,
    calendar: false,
    name: {
      value: "",
      state: true,
      error: "",
      rules: ["isRequired", "onlyLetters", "latinOrCyrilic", "minLength2"],
    },
    secondName: {
      value: "",
      state: true,
      error: "",
      rules: ["isRequired", "onlyLetters", "latinOrCyrilic", "minLength2"],
    },
    lastName: {
      value: "",
      state: true,
      error: "",
    },
    email: {
      value: "",
      state: true,
      error: "",
      rules: ["isRequired", "isCorrectEmail"],
    },
    emailCode: {
      value: "",
      state: true,
      error: "",
      rules: ["isRequired"],
    },
    phone: {
      value: "",
      state: true,
      error: "",
      rules: ["isCorrectPhone"],
    },
    password: {
      value: "",
      type: "password",
      state: true,
      error: "",
    },
    password_repeat: {
      value: "",
      state: true,
      error: "",
    },
    country: {
      value: "",
      state: true,
      error: "",
      rules: ["isRequired", "onlyLetters", "latinOrCyrilic", "minLength2"],
    },
    city: {
      value: "",
      state: true,
      error: "",
      rules: ["isRequired", "onlyLetters", "latinOrCyrilic", "minLength2"],
    },
    birthday: {
      value: "",
      state: true,
      error: "",
    },
  }),
  computed: {
    ...mapGetters(["Rules", "user", "SOCKET_MESSAGES"]),
    maskString() {
      if (this.countryCode.iso2 === "BY") {
        return `(##) ### - ## - ##`;
      }
      return `(###) ### - ## - ##`;
    },
    currentLocale() {
      return this.Trans.currentLocale;
    },
    countriesAssociation() {
      return {
        ru: "RU",
        kk: "KZ",
        be: "BY",
        mn: "MN",
        en: "US",
        ky: "KG",
        uz: "UZ",
        ka: "GE",
        et: "EE",
        lt: "LT",
        lv: "LV",
        az: "AZ",
        hy: "AM",
      };
    },
    profileFilled() {
      const fields = [
        "first_name",
        "last_name",
        "email",
        "ds_mobile",
        "ds_mailing_country",
        "birthday",
        "photo",
      ];
      let count = 0;
      for (let field of fields) {
        if (this.user[field]) {
          count++;
        }
      }
      return Math.round((count / fields.length) * 100);
    },
    userInfo() {
      return {
        first_name: this.name.value,
        last_name: this.secondName.value,
        middle_name: this.lastName.value,
        ds_mobile: this.phone.value
          ? (this.countryCode.dialCode + this.phone.value).replace(/\D/g, "")
          : "",
        email: this.email.value,
        ds_mailing_country: this.country.value,
        ds_mailing_city: this.city.value,
        birthday: this.birthday.value,
        ds_proc_country: this.countryCode.iso2,
      };
    },
  },
  methods: {
    ...mapActions([
      "fetchChangeUserData",
      "fetchChangeUserPhoto",
      "sendEmailConfirm",
      "sendEmailConfirmCode",
      "changePassword",
      "fetchAlerts",
      "SOCKET_SEND_MESSAGE",
    ]),
    onSelectCountry({ iso2, dialCode }) {
      this.countryCode = { iso2: iso2, dialCode: dialCode };
      this.fillUserData();
    },
    favoritesClick() {
      if (this.$gtm) {
        this.$gtm.push({
          event: "lk_goto_favorite",
        });
      }
      this.$router.push(this.helpers.buildRoute({ name: "Favorites" }));
    },
    statisticClick() {
      if (this.$gtm) {
        this.$gtm.push({
          event: "lk_goto_statistic",
        });
      }
      this.$router.push(this.helpers.buildRoute({ name: "Statistics" }));
    },
    cropImage() {
      this.$refs.cropper.upload();
      if (this.$gtm) {
        this.$gtm.push({
          event: "lk_personal_photo",
        });
      }
    },
    closeCalendar() {
      setTimeout(() => {
        this.calendar = false;
      }, 300);
    },
    async fillUserData() {
      this.$set(this.name, "value", this.user.first_name);
      this.$set(this.secondName, "value", this.user.last_name);
      if (this.user.email) {
        this.$set(this.email, "value", this.user.email);
      }
      if (this.countryCode.iso2 === "BY") {
        this.$set(
          this.phone,
          "value",
          this.user.ds_mobile
            ? this.user.ds_mobile.substring(this.user.ds_mobile.length - 9)
            : ""
        );
      } else {
        this.$set(
          this.phone,
          "value",
          this.user.ds_mobile
            ? this.user.ds_mobile.substring(this.user.ds_mobile.length - 10)
            : ""
        );
      }
      if (this.user.birthday) {
        this.$set(
          this.birthday,
          "value",
          this.user.birthday.split("-").reverse().join(".")
        );
      }

      this.$set(this.country, "value", this.user.ds_mailing_country || "");
      this.$set(this.city, "value", this.user.ds_mailing_city || "");
    },
    dayClick(day) {
      this.$set(
        this.birthday,
        "value",
        `${day.date.getDate().toString().padStart(2, 0)}.${(
          day.date.getMonth() + 1
        )
          .toString()
          .padStart(2, 0)}.${day.date.getFullYear()}`
      );
    },
    async emailConfirm() {
      const emailConfirmed = await this.sendEmailConfirm({
        id: this.user.id,
        email: this.email.value,
        pin: this.emailCode.value,
      });
      if (emailConfirmed) {
        this.modalToggle("confirmEmail", false);
        this.fetchAlerts({
          alerts: this.$t(`interface.saved`),
          type: "notify",
        });
      } else {
        this.$set(
          this.emailCode,
          "error",
          this.$t("interface.errors.wrongPin")
        );
        this.$set(this.emailCode, "state", false);
      }
    },
    async saveData() {
      if (this.validate(["email", "name", "secondName", "country", "city"])) {
        // if (this.email.value && !this.user.email) {
        //   const send = await this.sendEmailConfirmCode(this.email.value)
        //   if (send) {
        //     this.modalToggle('confirmEmail', true)
        //   }
        // }
        let res = await this.fetchChangeUserData(this.userInfo);
        if (res) {
          this.fetchAlerts({
            alerts: this.$t(`interface.saved`),
            type: "notify",
          });

          this.SOCKET_SEND_MESSAGE(
            JSON.stringify({
              action: "set_path",
              path: this.$router.resolve({
                name: this.$route.name.replace("Loc", ""),
              }).href,
            })
          );
        }
      }
      if (this.$gtm) {
        this.$gtm.push({
          event: "lk_personal_data_save",
        });
      }
    },
    async sendUserPhoto(data) {
      if (data) {
        const formData = new FormData();
        formData.append("photo", data);
        await this.fetchChangeUserPhoto(formData);
      }
    },
    modalToggle(model, state) {
      this[model] = state;
      bus.$emit("scrollLock", this.openedMenu);
    },
    showPass() {
      this.$set(
        this.password,
        "type",
        this.password.type === "text" ? "password" : "text"
      );
    },
    checkEqualPasswords() {
      let state = true;
      let result = this.Rules.notEqual(
        this.password.value,
        this.password_repeat.value,
        this.$t("interface.errors.passNotEquals")
      );
      if (typeof result === "string") {
        this.$set(this.password_repeat, "error", result);
        this.$set(this.password_repeat, "state", false);

        this.$set(this.password, "error", result);
        this.$set(this.password, "state", false);

        return;
      } else {
        this.$set(this.password_repeat, "error", "");
        this.$set(this.password_repeat, "state", true);

        this.$set(this.password, "error", "");
        this.$set(this.password, "state", true);
      }
      return state;
    },
    async setPass() {
      if (this.checkEqualPasswords()) {
        let changePass = await this.changePassword({
          password: this.password.value,
          password_repeat: this.password_repeat.value,
        });
        if (changePass === true) {
          this.fetchAlerts({
            alerts: this.$t(`interface.passChanged`),
            type: "notify",
          });
        } else {
          if (this.$te(`interface.errors.${changePass}`)) {
            this.$set(
              this.password,
              "error",
              this.$t(`interface.errors.${changePass}`)
            );
            this.$set(this.password, "state", false);
            this.$set(
              this.password_repeat,
              "error",
              this.$t(`interface.errors.${changePass}`)
            );
            this.$set(this.password_repeat, "state", false);
          } else {
            this.$set(
              this.password,
              "error",
              this.$t("interface.errors.passInvalid")
            );
            this.$set(this.password, "state", false);
            this.$set(
              this.password_repeat,
              "error",
              this.$t("interface.errors.passInvalid")
            );
            this.$set(this.password_repeat, "state", false);
          }
        }
      }
    },
  },
  mounted() {
    this.fillUserData();
  },
  watch: {
    user() {
      this.fillUserData();
    },
  },
};
</script>

<style lang="scss" scoped>
.userdata {
  &__avatar {
    position: relative;
    width: 155px;
    height: 155px;
    background: #d1d2cd;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;

    @media screen and (max-width: 743px) {
      width: 93px;
      height: 93px;
      margin: 0 auto;
    }

    &-edit {
      position: absolute;
      top: 0;
      right: 0;
      width: 44px;
      height: 44px;
      cursor: pointer;

      &-back {
        transition: 0.3s;
        color: #77bb2f;
      }

      &-item {
        transition: 0.3s;
        color: #fff;
      }

      &:hover {
        .userdata__avatar-edit-back {
          color: #ebf6e3;
        }

        .userdata__avatar-edit-item {
          color: #629727;
        }
      }
    }

    & img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      border-radius: 50%;
    }
  }
}
</style>
<style lang="scss" scoped>
.relative {
  position: relative;
}
.cabinet {
  &__body {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 137px;

    @media screen and (max-width: 1220px) {
      grid-template-columns: 1fr;
    }
  }

  &__warning {
    border: 1px solid #d1d2cd;

    svg {
      flex-shrink: 0;
    }
  }

  &__card {
    border: 1px solid #d1d2cd;
    position: relative;
    @media screen and (max-width: 743px) {
      height: 344px;

      & > div {
        height: 100%;
      }
    }
    .card__text {
      @media screen and (max-width: 743px) {
        position: relative;
        z-index: 2;
        height: 100%;
        display: flex;
        flex-direction: column;
      }
    }
    img {
      width: 30%;
      height: 100%;
      object-fit: contain;
      flex-shrink: 0;

      @media screen and (max-width: 743px) {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        margin: 0 !important;
        padding: 0 !important;
        width: 100%;
        height: 70%;
      }
    }
  }
}

.progress-modal {
  position: absolute;
  top: 30px;
  right: -50px;
  z-index: 10;
  width: 946px;

  &::before {
    position: absolute;
    bottom: 100%;
    right: 50px;
    display: block;
    width: 0;
    height: 0;
    border-left: 11px solid transparent;
    border-right: 11px solid transparent;

    border-bottom: 11px solid #eef3f7;

    content: "";
  }

  &__close {
    position: absolute;
    top: 15px;
    right: 13px;
    cursor: pointer;
  }

  &__levels {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  &__level {
    display: inline-flex;
    padding: 16px 32px;
    background-color: #f8f8f8;
    border-radius: 16px;
    border: 1px solid #d1d2cd;
    width: fit-content;

    &_active {
      border-color: #77bb2f;
      background-color: #ebf6e3;
    }
  }

  &__line {
    width: 100%;
    height: 1px;
    background-color: #b2b4b2;
  }
}
</style>
<style lang="scss">
.cabinet {
  & .vue-country-select .dropdown-list {
    z-index: 10;
  }

  & .vue-country-select {
    height: 56px;
    border-color: #d4d4d4;
  }

  & .vue-country-select .country-code {
    font-family: "Noto-Sans", sans-serif;
    font-weight: 400;
    font-size: 16px;
    color: #000;
  }

  & .vue-country-select:focus-within {
    box-shadow: none !important;
    border-color: #d4d4d4;
    outline: none;
  }
}
</style>
